import { render, staticRenderFns } from "./HttpLink.vue?vue&type=template&id=639990e0&scoped=true"
import script from "./HttpLink.vue?vue&type=script&lang=js"
export * from "./HttpLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639990e0",
  null
  
)

export default component.exports